<template>
	<VueSlider
		:value="value"
		:tooltip="tooltip"
		:tooltip-formatter="tooltipFormatter"
		:data="data"
		:min="min"
		:max="max"
		:marks="marks"
		:included="included"
		:enable-cross="enableCross"
		:hide-label="hideLabel"
		@change="setValue($event)"
	/>
</template>
<script lang="ts">
import '@cv/less/vue-slider.less'

import Vue from 'vue'
import VueSlider from 'vue-slider-component'

import BaseInput from '@cv/components/atoms/BaseInput.vue'

Vue.component('VueSlider', VueSlider)

export default Vue.extend({
	extends: BaseInput,
	props: {
		tooltip: {
			type: [String, null],
			default: null
		},
		tooltipFormatter: {
			type: Function,
			default: null
		},
		data: {
			type: Array,
			default: null
		},
		enableCross: {
			type: Boolean
		},
		hideLabel: {
			type: Boolean
		},
		included: {
			type: Boolean
		},
		marks: {
			type: Object,
			default: null
		},
		min: {
			type: Number,
			default: null
		},
		max: {
			type: Number,
			default: null
		}
	}
})
</script>
